import React, { useState } from 'react'
import { Button, Modal, Input, Form, Switch } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import dayjs from 'dayjs'
import { IModule, ITrame } from './util'
import { Modules } from './Modules'

interface IProps {
  baseUrl: string
  onSave: (v: ITrame[]) => void
  trames: ITrame[]
}

export const Trame = (props: IProps) => {
  const history = useHistory()
  const { tid } = useParams<{ tid: string }>()
  const [trame, setTrame] = useState<ITrame>(
    tid !== 'new'
      ? props.trames.find((t) => t.id === tid) || {
        id: uuid(),
        createdAt: dayjs().format(),
        updatedAt: dayjs().format(),
        name: '',
        modules: []
      }
      : {
        id: uuid(),
        createdAt: dayjs().format(),
        updatedAt: dayjs().format(),
        name: '',
        modules: [],
      },
  )

  // useEffect(() => {
  //   const newTrames = props.trames.some((d: ITrame) => d.id === trame.id)
  //     ? props.trames.map((d) => (d.id === trame.id ? trame : d))
  //     : props.trames.concat([trame])
  //   props.onSave(newTrames)
  // }, [trame])

  const saveTrameAndClose = () => {
    const newTrames =
      tid === 'new'
        ? props.trames.concat(trame)
        : props.trames.map((t: ITrame) => (t.id === tid ? trame : t))
    props.onSave(newTrames)
    history.push(props.baseUrl+"/trames")
  }

  const saveTrame = () => {
    const newTrames =
      tid === 'new'
        ? props.trames.concat(trame)
        : props.trames.map((t: ITrame) => (t.id === tid ? trame : t))
    props.onSave(newTrames)
  }

  return (
    <Modal
      visible={true}
      onCancel={() => history.push(props.baseUrl+"/trames")}
      maskClosable={false}
      okText="Enregistrer"
      cancelText="Annuler"
      onOk={saveTrameAndClose}
      closable={false}
      footer={[
        <Button key="Annuler" onClick={() => history.push(props.baseUrl+"/trames")}>
          Annuler
        </Button>,
        <Button key="Enregister" onClick={saveTrame}>
          Enregister
        </Button>,
        <Button key="Enregistrer et Fermer" onClick={saveTrameAndClose} type="primary">
          Enregistrer et Fermer
        </Button>,
      ]}
      width="90%"
    >
      <Form layout="vertical">
        <Form.Item label="Adhoc V2">
          <Switch checked={trame.versionAdhoc == 2} onChange={(e) => {
            setTrame({ ...trame, versionAdhoc: e ? 2 : 1 })
          }} />
        </Form.Item>
        <Form.Item label="Nom de la trame">
          <Input
            placeholder="Trame 1"
            value={trame.name}
            onChange={(e) => setTrame({ ...trame, name: e.target.value })}
          />
          <Modules
            modules={trame.modules}
            onSave={(m: IModule[]) => setTrame({ ...trame, modules: m })}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
